(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-image"] && !Shopify.designMode) return;
  try {
    // Handle lazy loading with fade-in effect
  document.addEventListener('DOMContentLoaded', function() {
    const lazyImages = document.querySelectorAll('.responsive-image img[loading="lazy"]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          
          // If image is already loaded, show it immediately
          if (img.complete) {
            img.classList.add('loaded');
          } else {
            // Otherwise wait for load event
            img.addEventListener('load', function() {
              img.classList.add('loaded');
            });
            
            // Fallback: if load event doesn't fire, show after a delay
            setTimeout(() => {
              if (!img.classList.contains('loaded')) {
                img.classList.add('loaded');
              }
            }, 1000);
          }
          
          observer.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__contentImageStickyOverlayInit) return;
    window.__contentImageStickyOverlayInit = true;

    function getHeaderHeight() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      var parsed = parseFloat(raw);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    function updateOverlay(track) {
      var image = track.querySelector('[data-sticky-overlay-image]');
      if (!image) return;

      var offsetTop = parseFloat(track.dataset.stickyOffsetTop) || 0;
      var inset = parseFloat(track.dataset.stickyInset) || 0;
      var container = track.closest('.content-image') || track;
      var containerRect = container.getBoundingClientRect();
      var badgeHeight = image.offsetHeight;
      if (!badgeHeight) return;

      // Respect CSS padding (includes --header-height on transparent heroes)
      var paddingTop = parseFloat(getComputedStyle(track).paddingTop);
      if (!Number.isFinite(paddingTop)) paddingTop = offsetTop;

      var stickyTop = getHeaderHeight() + offsetTop;
      var maxTranslate = Math.max(0, container.clientHeight - paddingTop - inset - badgeHeight);
      var translateY = stickyTop - (containerRect.top + paddingTop);

      if (translateY < 0) translateY = 0;
      if (translateY > maxTranslate) translateY = maxTranslate;

      image.style.transform = 'translate3d(0, ' + translateY + 'px, 0)';
    }

    function updateAll() {
      document.querySelectorAll('[data-sticky-overlay]').forEach(updateOverlay);
    }

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        updateAll();
        ticking = false;
      });
    }

    function bindImageLoads() {
      document.querySelectorAll('[data-sticky-overlay-image]').forEach(function(image) {
        if (image.dataset.stickyOverlayBound === 'true') return;
        image.dataset.stickyOverlayBound = 'true';
        if (!image.complete) {
          image.addEventListener('load', updateAll, { once: true });
        }
      });
    }

    function init() {
      bindImageLoads();
      updateAll();
      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize);
      document.addEventListener('shopify:section:load', function() {
        bindImageLoads();
        updateAll();
      });

      window.ThemeBus = window.ThemeBus || new EventTarget();
      window.ThemeBus.addEventListener('header-height:update', onScrollOrResize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
